// eslint-disable-next-line no-new-func -- This needs to be a dynamic import, and it is the only way to get TypeScript to leave this allone
const dynamicConfig = await new Function("return import('/static/config/overrides.js')")()

export const ConfigOverrides: Record<string, string> = {
  ...dynamicConfig.default,
}
